import { IMenuGroupImprovement } from '../../types/menuGroups';
import MenuGroupImprovementListRowSkeleton from './MenuGroupImprovementListRowSkeleton';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';

interface IProps {
  menuGroupImprovement?: IMenuGroupImprovement;
}

const MenuGroupImprovementListRow = ({ menuGroupImprovement }: IProps): JSX.Element => {
  const onSelectMenuGroup = () => {
    if (!menuGroupImprovement) return;
    window.open(menuGroupImprovement.link, '_blank');
  };

  return (
    <div className="menu-groups-list-row d-flex cursor-pointer full-width" onClick={onSelectMenuGroup}>
      {menuGroupImprovement ? (
        <>
          <div className="d-flex flex-row align-items-center  w-40 pr-4">
            <Text style={{ wordBreak: 'break-word', whiteSpace: 'normal' }} type={TEXT.LIST_ROW} text={menuGroupImprovement.error} />
          </div>
          <div className="d-flex flex-row align-items-center w-60">
            <div className="backend-link">{menuGroupImprovement.link}</div>
          </div>
        </>
      ) : (
        <MenuGroupImprovementListRowSkeleton />
      )}
    </div>
  );
};

export default MenuGroupImprovementListRow;
